import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FieldConfig } from '../../_models/field.interface';
import { FidelidadeService } from '../../_services/fidelidade.service';
import { TipoDesconto } from '../../_models/Enums/tipoDesconto';

@Component({
  selector: 'app-desconto-lovers',
  templateUrl: './desconto-lovers.component.html',
  styleUrls: ['./desconto-lovers.component.scss'],
})
export class DescontoLoversComponent implements OnInit {
  regLabelMenuCacauLover: FieldConfig[] = [];
  regProdutosDesconto: FieldConfig[] = [];

  produtos: FieldConfig[] = [];

  public carregandoDescontos: boolean = false;

  constructor(
    private location: Location,
    private fidelidadeService: FidelidadeService
  ) {}

  ngOnInit(): void {
    this.carregarElementos();
    this.obterDescontosLovers();
  }

  carregarElementos(): void {
    this.regLabelMenuCacauLover = [
      {
        type: 'labelImage',
        label: 'Desconto para Lovers',
        icon: ['assets/images/icons/voltar.png'],
        style(): object {
          return {
            'font-family': 'Sagona',
            'font-style': 'normal',
            'font-weight': '600',
            'font-size': '24px',
            color: '#461F1A',
            'letter-spacing:': '-0.01em',
            'white-space': 'pre-line',
            height: '0px',
            'padding-left': '2rem',
            'padding-top': '1.6rem',
          };
        },
        onClick: () => {
          this.location.back();
        },
      },
    ];
  }

  obterDescontosLovers(): void {
    this.carregandoDescontos = true;
    this.fidelidadeService
      .obterDescontosParaLovers(TipoDesconto.DESCONTOS_PARA_LOVERS)
      .subscribe(
        (sucesso) => this.processarSucessoDescontos(sucesso),
        (falha) => this.processarFalhaDescontos(falha)
      );
  }

  processarSucessoDescontos(res: any): void {
    res.forEach((p) => {
      this.produtos.push({
        type: 'contentCard',
        src: 'data:image/jpg;base64,' + p.imagemBase64,
        label: p.titulo,
        mainIcon: 'fa-shopping-cart',
        buttonLabel: '',
        singleLink: 'https://www.google.com.br/',
      });
    });

    this.carregarComponentesDesconto();
  }

  processarFalhaDescontos(err: any): void {
    console.error('Ocorreu um erro ao tentar obter os descontos', err);
    this.carregandoDescontos = false;
  }

  carregarComponentesDesconto(): void {
    this.regLabelMenuCacauLover = [
      {
        type: 'labelImage',
        label: 'Descontos para Lovers',
        icon: ['assets/images/icons/voltar.png'],
        style(): object {
          return {
            'font-family': 'Sagona',
            'font-style': 'normal',
            'font-weight': '600',
            'font-size': '20px',
            color: '#461F1A',
            'padding-left': '50px',
            'padding-top': '19px',
          };
        },
        onClick: () => {
          this.location.back();
        },
      },
    ];

    this.regProdutosDesconto = this.produtos;

    this.carregandoDescontos = false;
  }

  voltarPaginaAnterior() {
    this.location.back();
  }
}
